up.compiler('[data-confirm]', (element) => {

  // Unpoly respects [data-confirm] only for links/buttons it handles itself.
  // This compiler is intended for links with [up-follow="false"], or buttons inside a form[up-submit="false"].
  // An example for this are links/forms with [target="_blank"], like sign-out buttons which do a full page load.

  function onClick(event) {
    const message = element.getAttribute('data-confirm')
    if (!confirm(message)) up.event.halt(event)
  }

  element.addEventListener('click', onClick)
})
